export interface Code {
	code: string;
	frequency: number;
}

export interface OverallTaskRisk {
	score: string;
	percentage: number;
	codes: Code[];
}

export interface Value {
	id: string;
	score: number;
	percentage: number;
	description: string;
}

export interface RiskBySegment {
	id: string;
	description: string;
	values: Value[];
}

interface Task {
	id: string;
	name: string;
	frequency: number;
	worst_score: number;
	activity_tools: string;
	risk_by_segment: RiskBySegment[];
	overall_task_risk: OverallTaskRisk[];
}

export class TasksResult {
	public readonly id: string;
	public readonly name: string;
	public readonly frequency: number;
	public readonly worst_score: number;
	public readonly activity_tools: string;
	public readonly risk_by_segment: RiskBySegment[];
	public readonly overall_task_risk: OverallTaskRisk[];

	constructor({
		id,
		name,
		frequency,
		worst_score,
		activity_tools,
		risk_by_segment = [],
		overall_task_risk = []
	}: Task) {
		this.id = id;
		this.name = name;
		this.frequency = frequency;
		this.worst_score = worst_score;
		this.activity_tools = activity_tools;
		this.risk_by_segment = risk_by_segment;
		this.overall_task_risk = overall_task_risk;
	}
}
